import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 sm:px-6 bg-graphite text-center text-ivory/60 text-xs sm:text-sm" data-id="element-74">
      <p className="leading-relaxed max-w-3xl mx-auto font-medium mb-6" data-id="element-75">
        © {new Date().getFullYear()} Fitness Senior Ready™ — All Rights
        Reserved.
        <br data-id="element-76" />
        The content of this page is for educational purposes only and does not
        replace professional medical advice. Always follow appropriate safety
        guidelines when working with older adults.
      </p>
      <div className="flex justify-center gap-4 sm:gap-6 font-bold tracking-widest uppercase text-[10px] sm:text-xs" data-id="element-77">
        <a href="#" className="hover:text-gold transition-colors" data-id="element-78">
          Terms & Conditions
        </a>
        <span data-id="element-79">·</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-80">
          Privacy Policy
        </a>
        <span data-id="element-81">·</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-82">
          Contact
        </a>
      </div>
    </footer>;
}